import React, { useEffect } from 'react';

export default function RegisterDrawerComponent({ children, isOpen }: { isOpen: boolean; children?: React.ReactNode }) {
    useEffect(() => {
        const body = document.body;
        if (isOpen) {
          body.style.overflow = 'hidden';
        } else {
          body.style.overflow = '';
        }
    
        return () => {
          body.style.overflow = '';
        };
      }, [isOpen]);
  return (
    <>
      {isOpen && (
        <div
          className={`fixed inset-0 z-50 p-16 flex items-center justify-center transition-opacity duration-250 ${isOpen ? 'visible opacity-100' : 'invisible opacity-0'
            }`}
        >
          <div
            className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm "
            onClick={(e) => {
              e.stopPropagation();
            }}
          ></div>

          <div
            className="relative z-10 w-full max-w-[542px] bg-white md:px-40 md:py-30 p-20 registerDrawer"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
}
